// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"422":"b7f01eca","668":"36f7b4e0"}[chunkId] + ".chunk.js");